import makeStyles from '@material-ui/core/styles/makeStyles';
export var useStyles = makeStyles({
    backgroundWrapper: {
        position: 'relative',
    },
    backgroundTop: {
        position: 'absolute',
        top: 0,
        height: '24px',
        width: '100%',
        background: 'linear-gradient(180deg, #000 0%, rgba(36, 36, 36, 0.58) 50%, rgba(84, 84, 84, 0.00) 100%)',
        opacity: 0.189,
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: '17px 25px 18px 37px',
        marginBottom: '11px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.57)',
    },
    avatar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: '50px',
        '& img': {
            width: '70px',
            height: '70px',
        },
        '& span': {
            minWidth: '70px',
            textAlign: 'center',
            fontSize: '12px',
            color: '#FFFFFF',
        },
        '@media (max-width:376px)': {
            marginRight: '10px',
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        color: '#6CFF00',
    },
    divider: {
        width: '100%',
        minWidth: '195px',
        height: '1px',
        margin: '10px 0',
        backgroundColor: '#FFFFFF',
        border: '0.5px #FFFFFF'
    },
    level: {
        fontSize: '25px',
        fontWeight: 700,
        color: '#6CFF00',
        textTransform: 'uppercase',
    },
    rank: {
        textTransform: 'capitalize',
    },
    myCredits: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        fontSize: '12px',
    },
    balance: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 700,
        '& svg': {
            marginLeft: '5px',
        },
        '& img': {
            marginLeft: '5px',
        }
    },
    mt108: {
        marginTop: '108px',
    },
    noneTextTransform: {
        textTransform: 'none',
    },
}, { name: 'UserCardCartoon' });
